import type { ApiPhoto } from '../../api/types';

import { REPLIES_USER_ID, VERIFICATION_CODES_USER_ID } from '../../config';

export function getBotCoverMediaHash(photo: ApiPhoto) {
  return `photo${photo.id}?size=x`;
}

export function isSystemBot(botId: string) {
  return botId === REPLIES_USER_ID || botId === VERIFICATION_CODES_USER_ID;
}
